import { prop } from 'ramda';
import { createSelector } from 'reselect';

import { USER_ROLES } from 'constants/general';
import user from 'features/views/user';

import { NAME } from './constants';

const getRoot = prop(NAME);

const getAssignedCountInner = createSelector(getRoot, prop('assignedCount'));
const getAvailableCountInner = createSelector(getRoot, prop('availableCount'));

export const getAssignedCount = createSelector(
	user.selectors.getCurrentRole,
	getAssignedCountInner,
	(userRole, assignedCount) => (USER_ROLES.SELLER !== userRole ? assignedCount : 0),
);

export const getAvailableCount = createSelector(
	user.selectors.getCurrentRole,
	getAssignedCountInner,
	getAvailableCountInner,
	(userRole, assignedCount, availableCount) =>
		USER_ROLES.SELLER !== userRole ? availableCount : availableCount - assignedCount,
);
